'use strict'

module.exports = {
  API_KEY: 'THE_KEY',
  // API_URL: 'https://submissions.annieawards.org/api',
  // API_URL: 'http://v2-annies.test/api'
  API_URL: window.location.origin+'/api',
  // LIVE: https://submissions.annieawards.org/api
}



// WEBPACK FOOTER //
// ./config/myannieawards.js